import React from 'react';
import { Anchor, Paragraph, Popover, Popper, Tag } from '@zillow/constellation';
import { EXPERIAN_IDENTITY_MANAGEMENT_URL } from '../../constants/urls';

const IS_NOT_VERIFIED_TEXT = 'Identity Not Verified';

export default function NotIdVerifiedTag() {
  return (
    <>
      <Tag appearance="warning">{IS_NOT_VERIFIED_TEXT}</Tag>
      <Popper
        triggered={
          <Popover
            renderCloseButton={false}
            body={
              <Paragraph>
                Zillow’s partner,{' '}
                <Anchor href={EXPERIAN_IDENTITY_MANAGEMENT_URL} target="_blank">
                  Experian
                </Anchor>
                , has reviewed the applicant’s personal information for indications of fraud. In this instance, Experian
                was unable to find an identity match based on the personal information provided by this applicant. While
                this could be an indication of fraud, it could also be due to Experian having incomplete information
                about the applicant. As a result, it is recommended you review the applicant’s government-issued ID or
                other documentation before making a leasing decision.
              </Paragraph>
            }
          />
        }
      />
    </>
  );
}
